import { useDispatch, useSelector } from "react-redux";
import store from "src/store/store";
import JPMorgan from "src/assets/JPMorgan.svg";
import Payments from "src/assets/Payments.svg";
import { Display3, Link } from "@salt-ds/core";
import Tabs from "./Tabs";
import { useNavigate } from "react-router-dom";
import { setShowHeaderFlag } from "src/reducers/slices/SetSecDataSlice";
import ButtonComponent from "src/components/ButtonComponent";
import {VC, VCN} from "src/utils/Constants";
import {pagePath} from "src/app/Routers";

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const secData = useSelector(
    (state: ReturnType<typeof store.getState>) => state.getSecData.value,
  );

  const headerStr =
    secData?.secDataDetails?.content?.overview?.conteDataDetails[0]
      ?.contentData;

  const navigate = useNavigate();
  const handleEnrollClick = () => {
    const contentTargetEnrollment =
      secData?.secDataDetails?.content?.contentTargetEnrollment;
    if (contentTargetEnrollment === VC) {
      window.open(
        `${import.meta.env.VITE_APP_ENROLLNOW_BUTTON_URL}${
          secData?.secDataDetails?.content?.payments[0]?.encryptedCaseId
        }`,
        "_blank",
      );
    } else if (contentTargetEnrollment === VCN) {
      dispatch(setShowHeaderFlag(false));
      navigate(pagePath.enrollVCN);
    }
  };

  const getEnrollmentButton = () => {
    const contentTargetEnrollment =
      secData?.secDataDetails?.content?.contentTargetEnrollment;
    if (contentTargetEnrollment === VC) {
      return (
        <ButtonComponent
          label="Enroll in Virtual Card"
          onClick={handleEnrollClick}
          variant={"cta"}
          className="normal-case absolute text-[14px] mt-[92px] mx-auto right-[24px]  h-8 px-[12px] py-[7px] font-medium font-['Amplitude'] leading-[18px] tracking-tight bg-customBlue rounded"
        />
      );
    }
    if (contentTargetEnrollment === VCN) {
      return (
        <ButtonComponent
          label="Enroll in Virtual Connect Network"
          onClick={handleEnrollClick}
          variant={"cta"}
          className="normal-case absolute text-[14px] mt-[92px] mx-auto right-[24px]  h-8 px-[12px] py-[7px] font-medium font-['Amplitude'] leading-[18px] tracking-tight bg-customBlue rounded"
        />
      );
    }
  };

  return (
    <>
      <header className="sticky w-full top-0  h-[135px]  bg-white shadow flex-col  inline-flex z-50">
        <div className="mx-auto my-[20px]  w-[683px] h-8 justify-center items-center inline-flex ">
          <Display3>{headerStr}</Display3>
        </div>
        <div className="ml-[24px] absolute my-[25px]  w-[273px] gap-[16.58px] h-11 justify-start items-start inline-flex ">
          <div className="w-[161.08px] h-8 relative">
            <img src={JPMorgan} alt="JPMorgan" />
          </div>
          <div className="w-[69.86px] my-auto h-[10.62px] relative">
            <img src={Payments} alt="Payments" />
          </div>
        </div>
        {/*<Button className=" w-[170px] h-8 px-2 py-[7px] bg-cyan-700 rounded ml-8 normal-case" variant="cta" onClick={handleSkipClick}>Skip to Main Content</Button>*/}
        <Link
          href="#mainContent"
          style={{ textDecoration: "underline" }}
          className="absolute mb-[57px] mt-[62px] ml-[24px] left-[-999px] top-0 focus:left-0 focus:top-0 focus:z-50 underline-offset-1 focus:text-skipLink p-2 "
        >
          Skip to Main Content
        </Link>
        <div className="mx-auto my-[29px]  h-8 pr-[0.01px] justify-center items-center gap-[16.58px] inline-flex  ">
          <Tabs />
        </div>

        {getEnrollmentButton()}
      </header>
    </>
  );
};
export default Header;
